import useUserStore, { TextField } from "@/state/user/useUserStore";
import { X } from "lucide-react";
import React, { SyntheticEvent, useEffect, useState } from "react";
import { Frame, NumberInput, Select, TextInput } from "react95";
import { SelectOption } from "react95/dist/Select/Select.types";
import { CloseButton } from "@/components/styles";
import { useMediaQuery } from "@mantine/hooks";

export const TextInputComponent: React.FC<{
  textField: TextField;
  color: string;
  index: number;
}> = ({ textField, color, index }) => {
  const [updateTextField, removeTextField, restrictedFonts] = useUserStore(
    (state) => [
      state.updateTextField,
      state.removeTextField,
      state.restrictedFonts,
    ]
  );

  const options =
    restrictedFonts && restrictedFonts.length > 0
      ? restrictedFonts
      : [
          { value: "title1", label: "Honey" },
          { value: "title2", label: "Comic" },
          { value: "title3", label: "Pixel" },
          { value: "title4", label: "Henlo1" },
          { value: "title5", label: "Henlo2" },
          { value: "title6", label: "Henlo3" },
          { value: "title7", label: "Henlo4" },
          { value: "title8", label: "Henlo5" },
          { value: "title9", label: "Impact" },
          { value: "title10", label: "Lowpoly" },
          { value: "title11", label: "Bullas" },
          { value: "title12", label: "Puffpaw" },
        ];

  const onChangeFont = (
    selectedOption: SelectOption<string>,
    { fromEvent }: { fromEvent: Event | SyntheticEvent<Element, Event> }
  ) => {
    updateTextField(textField.id, {
      ...textField,
      font: selectedOption.value as string,
    });
  };

  const [strokeColor, setStrokeColor] = useState("#ffffff");

  useEffect(() => {
    updateTextField(textField.id, {
      ...textField,
      color: strokeColor,
    });
  }, [strokeColor]);

  const isSmallScreen = useMediaQuery("(max-width: 768px)");

  return (
    <>
      <div
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "row",
          boxSizing: "border-box",
          alignItems: "center",
          justifyContent: "space-between",
          marginBottom: "8px",
        }}
      >
        <h1
          style={{
            margin: 0,
            fontSize: "24px",
            fontFamily: "var(--font-cabin-condensed)",
          }}
        >
          Text Field {textField.index}
        </h1>
        <CloseButton
          color={color}
          onClick={() => removeTextField(textField.id)}
        >
          <X style={{ width: "12px", height: "12px" }} />
        </CloseButton>
      </div>
      <div
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          gap: "12px",
          // height: "32px",
          marginBottom: "36px",
          boxSizing: "border-box",
          justifyContent: "flex-start",
          alignItems: "flex-start",
        }}
      >
        <TextInput
          placeholder="Text"
          style={{
            width: "100%",
            height: "100%",
            flex: 1,
            fontFamily: "var(--font-cabin-condensed)",
          }}
          value={textField.text}
          onChange={(e) =>
            updateTextField(textField.id, {
              ...textField,
              text: e.target.value,
            })
          }
        />
        <div
          style={{
            display: "flex",
            flexDirection: isSmallScreen ? "column" : "row",
            gap: "8px",
            width: "100%",
          }}
        >
          <div
            style={{
              width: "100%",
              display: "grid",
              gridTemplateColumns: "repeat(8, minmax(0, 1fr))",
              gap: "4px",
              boxSizing: "border-box",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Frame
              variant="field"
              style={{
                background: "#ffffff",
                aspectRatio: "1/1",
                cursor: "pointer",
                border: strokeColor === "#ffffff" ? "3px solid #060083" : "",
              }}
              onClick={() => setStrokeColor("#ffffff")}
            />
            <Frame
              variant="field"
              style={{
                background: "#ed1c24",
                aspectRatio: "1/1",
                cursor: "pointer",
                border: strokeColor === "#ed1c24" ? "3px solid #060083" : "",
              }}
              onClick={() => setStrokeColor("#ed1c24")}
            />
            <Frame
              variant="field"
              style={{
                background: "#ff7e00",
                aspectRatio: "1/1",
                cursor: "pointer",
                border: strokeColor === "#ff7e00" ? "3px solid #060083" : "",
              }}
              onClick={() => setStrokeColor("#ff7e00")}
            />

            <Frame
              variant="field"
              style={{
                background: "#eeba03",
                aspectRatio: "1/1",
                cursor: "pointer",
                border: strokeColor === "#eeba03" ? "3px solid #060083" : "",
              }}
              onClick={() => setStrokeColor("#eeba03")}
            />
            <Frame
              variant="field"
              style={{
                background: "#fff200",
                aspectRatio: "1/1",
                cursor: "pointer",
                border: strokeColor === "#fff200" ? "3px solid #060083" : "",
              }}
              onClick={() => setStrokeColor("#fff200")}
            />
            <Frame
              variant="field"
              style={{
                background: "#a8e61d",
                aspectRatio: "1/1",
                cursor: "pointer",
                border: strokeColor === "#a8e61d" ? "3px solid #060083" : "",
              }}
              onClick={() => setStrokeColor("#a8e61d")}
            />
            <Frame
              variant="field"
              style={{
                background: "#22b14c",
                aspectRatio: "1/1",
                cursor: "pointer",
                border: strokeColor === "#22b14c" ? "3px solid #060083" : "",
              }}
              onClick={() => setStrokeColor("#22b14c")}
            />
            <Frame
              variant="field"
              style={{
                background: "#9dbb61",
                aspectRatio: "1/1",
                cursor: "pointer",
                border: strokeColor === "#9dbb61" ? "3px solid #060083" : "",
              }}
              onClick={() => setStrokeColor("#9dbb61")}
            />
            <Frame
              variant="field"
              style={{
                background: "#00b7ef",
                aspectRatio: "1/1",
                cursor: "pointer",
                border: strokeColor === "#00b7ef" ? "3px solid #060083" : "",
              }}
              onClick={() => setStrokeColor("#00b7ef")}
            />
            <Frame
              variant="field"
              style={{
                background: "#99d9ea",
                aspectRatio: "1/1",
                cursor: "pointer",
                border: strokeColor === "#99d9ea" ? "3px solid #060083" : "",
              }}
              onClick={() => setStrokeColor("#99d9ea")}
            />
            <Frame
              variant="field"
              style={{
                background: "#4d6df3",
                aspectRatio: "1/1",
                cursor: "pointer",
                border: strokeColor === "#4d6df3" ? "3px solid #060083" : "",
              }}
              onClick={() => setStrokeColor("#4d6df3")}
            />
            <Frame
              variant="field"
              style={{
                background: "#709ad1",
                aspectRatio: "1/1",
                cursor: "pointer",
                border: strokeColor === "#709ad1" ? "3px solid #060083" : "",
              }}
              onClick={() => setStrokeColor("#709ad1")}
            />
            <Frame
              variant="field"
              style={{
                background: "#2f3699",
                aspectRatio: "1/1",
                cursor: "pointer",
                border: strokeColor === "#2f3699" ? "3px solid #060083" : "",
              }}
              onClick={() => setStrokeColor("#2f3699")}
            />
            <Frame
              variant="field"
              style={{
                background: "#546d8e",
                aspectRatio: "1/1",
                cursor: "pointer",
                border: strokeColor === "#546d8e" ? "3px solid #060083" : "",
              }}
              onClick={() => setStrokeColor("#546d8e")}
            />
            <Frame
              variant="field"
              style={{
                background: "#6f3198",
                aspectRatio: "1/1",
                cursor: "pointer",
                border: strokeColor === "#6f3198" ? "3px solid #060083" : "",
              }}
              onClick={() => setStrokeColor("#6f3198")}
            />
            <Frame
              variant="field"
              style={{
                background: "#b5a5d5",
                aspectRatio: "1/1",
                cursor: "pointer",
                border: strokeColor === "#b5a5d5" ? "3px solid #060083" : "",
              }}
              onClick={() => setStrokeColor("#b5a5d5")}
            />
          </div>
          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "row",
              gap: "8px",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Select
              style={{ height: "36px" }}
              options={options}
              width={isSmallScreen ? "65%" : "125px"}
              onChange={onChangeFont}
              menuMaxHeight={160}
            />
            <NumberInput
              width={isSmallScreen ? "35%" : "90px"}
              style={{ height: "36px" }}
              value={textField.fontSize}
              max={96}
              min={20}
              onChange={(e) =>
                updateTextField(textField.id, {
                  ...textField,
                  fontSize: e,
                })
              }
              step={8}
            />
          </div>
        </div>
      </div>
    </>
  );
};
